<template>
  <AppSkeletonCardTable v-if="loadingList"></AppSkeletonCardTable>
  <Card v-else>
    <template v-slot:title>
      Bovinos
      <router-link
        :to="{ name: 'bovine.list', query: { farmId: id } }"
        target="_blank"
      >
        <br class="hide mobile-show">
        <span style="font-size: 1rem; font-weight: normal">
          (Listagem de Bovinos da fazenda)
        </span>
      </router-link>
    </template>
    <template v-slot:content>
      <BovineDataTable
        :results="results"
        :scrollHeight="'500px'"
        :columns="[{ field: 'farm', hide: true }]"
      />
      <Paginator
        :first="query.pageSize * pagination.current - 1"
        :rows="query.pageSize"
        :totalRecords="pagination.total"
        @page="changeListPage({ page: $event.page + 1 })"
      ></Paginator>
    </template>
  </Card>
</template>

<script>
import useApiList from '../../../lib/useApiList';
import { BovineApi } from '../../../services/api';
import BovineDataTable from '../../../components/BovineDataTable.vue';

export default {
  name: 'BovineCalvesCard',
  props: {
    id: Number,
  },
  components: {
    BovineDataTable,
  },
  setup(props) {
    return {
      ...useApiList(BovineApi, {
        farmId: props.id,
        pageSize: 10,
        available: true,
      }),
    };
  },
  data() {
    return {
      headerStyle: 'width: 100px',
    };
  },
  async created() {
    await this.fetchList();
  },
};
</script>

<style>
</style>
